export const jobTitles : string[] = [
  'Logistics Coordinator',
  'Supply Chain Manager',
  'Freight Forwarder',
  'Customs Broker',
  'Warehouse Manager',
  'Transport Manager',
  'Import/Export Specialist',
  'Air Freight Specialist',
  'Sea Freight Coordinator',
  'Project Cargo Manager',
  'Operations Manager',
  'Logistics Analyst',
  'Distribution Manager',
  'Inventory Control Specialist',
  'Fleet Manager',
  'Courier Services Manager',
  'Cold Chain Manager',
  'Hazardous Materials Specialist',
  'E-commerce Logistics Coordinator',
  'Aerospace Logistics Specialist',
  'Retail Logistics Manager',
  'Logistics Project Manager',
  'Shipping Manager',
  'Freight Operations Manager',
  'Supply Chain Analyst',
  'Inventory Manager',
  'Warehouse Operations Supervisor',
  'Logistics Consultant',
  'Transport Planner',
  'Export Compliance Specialist',
  'Transportation Analyst',
  'Logistics Sales Executive',
  'Customs Compliance Manager',
  'Customs Operations Manager',
  'Customs Clearance Specialist',
  'Customs Data Entry Clerk',
  'Customs Auditor',
  'Trade Compliance Specialist',
  'Customs Broker Assistant',
  'Customs Policy Analyst',
  'Customs Analyst',
  'Import Coordinator',
  'Import Specialist',
  'Import Compliance Officer',
  'Import Documentation Specialist',
  'Import Operations Manager',
  'Export Coordinator',
  'Export Specialist',
  'Export Compliance Officer',
  'Export Documentation Specialist',
  'Export Operations Manager',
  'Rail Freight Manager',
  'Air Cargo Manager',
  'Maritime Logistics Coordinator',
  'Fleet Operations Coordinator',
  'Logistics Quality Assurance Specialist',
  'Supplier Relationship Manager',
  'Risk Management Specialist',
  'Demand Planner',
  'Distribution Center Supervisor',
  'Procurement Manager',
  'Logistics Technology Specialist',
  'Sourcing Specialist',
  'Logistics Research Analyst',
  'Reverse Logistics Coordinator',
  'Process Improvement Manager',
  'Transportation Safety Manager',
  'Brokering Specialist',
  'Last-Mile Delivery Manager',
  'Marine Operations Manager',
  'Energy Logistics Manager',
  'Contract Logistics Manager',
  'Transportation Compliance Officer',
  'Global Logistics Manager',
  'Operational Excellence Manager',
  'Cross-Docking Coordinator',
  'Material Handling Supervisor',
  'Cook',
  'Chef',
  'Food Service Manager',
  'Delivery Driver',
  'Truck Driver',
  'Forklift Operator',
  'IT Manager',
  'Software Developer',
  'Web Developer',
  'App Developer',
  'Frontend Developer',
  'Backend Developer',
  'Full Stack Developer',
  'Mobile App Developer',
  'DevOps Engineer',
  'Systems Analyst',
  'Network Administrator',
  'Database Administrator',
  'IT Support Specialist',
  'Cybersecurity Analyst',
  'Cloud Solutions Architect',
  'Project Manager (IT)',
  'Data Analyst',
  'Technical Support Engineer',
  'Business Analyst',
  'Quality Assurance Tester',
  'UI/UX Designer',
  'Digital Marketing Specialist',
  'E-commerce Manager',
  'IT Consultant',
  'SEO Specialist',
  'SEO Analyst',
  'Content Strategist',
  'Social Media Manager',
  'PPC Specialist',
  'SEO Copywriter',
  'Link Building Specialist',
  'HR Manager',
  'HR Specialist',
  'Recruitment Coordinator',
  'Talent Acquisition Manager',
  'Employee Relations Manager',
  'Training and Development Manager',
  'Payroll Specialist',
  'Compensation Analyst',
  'HR Coordinator',
  'HR Business Partner',
  'Office Manager',
  'Administrative Assistant',
  'Executive Assistant',
  'Personal Secretary',
  'Receptionist',
  'Accounts Payable Specialist',
  'Accounts Receivable Specialist',
  'Staff Accountant',
  'Financial Analyst',
  'Accounting Manager',
  'Controller',
  'Chief Financial Officer (CFO)',
  'Sales Manager',
  'Sales Executive',
  'Account Executive',
  'Sales Coordinator',
  'Business Development Manager',
  'Sales Analyst',
  'Territory Sales Manager',
  'Sales Representative',
  'Project Manager',
  'Project Coordinator',
  'Program Manager',
  'Project Scheduler',
  'Project Assistant',
  'Sports Manager',
  'Athletic Director',
  'Director',
  'Procurement Director',
  'Supply Chain Director',
  'Operations Director',
  'Sports Marketing Manager',
  'Sports Event Coordinator',
  'Fitness Coordinator',
  'Team Leader',
  'Team Lead (Logistics)',
  'Team Lead (Sales)',
  'Team Lead (IT)',
  'Team Lead (HR)',
  'Road Coordinator',
  'Road Team Leader',
  'Air Team Leader',
  'Sea Team Leader',
  'Security Manager',
  'Security Officer',
  'Loss Prevention Specialist',
  'Security Analyst',
  'Risk Assessment Specialist',
  'Compliance Officer',
  'Cybersecurity Specialist',
  'Physical Security Specialist',
  'Security Systems Administrator',
  'Chief Executive Officer (CEO)',
  'President',
  'Managing Director',
  'Executive Director',
  'Vice President',
  'General Manager',
  'Regional General Manager',
  'Senior General Manager',
  'Operations General Manager',
  'General Manager (Logistics)',
  'General Manager (Sales)',
  'General Manager (IT)',
  'General Manager (HR)',
  'General Manager (Finance)',
  'Strategic Partnerships Manager',
  'Market Research Analyst',
  'Business Operations Manager',
  'Product Manager',
  'Brand Manager',
  'Customer Experience Manager',
  'Corporate Development Manager',
  'Business Intelligence Analyst',
  'Financial Consultant',
  'Investment Analyst',
  'Revenue Analyst',
  'Supply Chain Consultant',
  'Compliance Manager',
  'Change Management Consultant',
  'Sales Enablement Manager',
  'Client Relationship Manager',
  'Business Continuity Manager',
  'Product Marketing Manager',
  'Analytics Manager',
  'Legal Counsel',
  'Market Development Manager',
  'Sustainability Manager'
];